import UserInfo from "@/app/types/UserInfo";
import makeAccountMenu from "@/app/util/makeAccountMenu";
import Link from "next/link";
import {useCookieCampusId} from "../../contexts/CampusCookieContext";

const MobileMenuAccountHeader: React.FC<UserInfo> = (props) => {
	const campusId = useCookieCampusId();
	const accountMenuItems = props ? makeAccountMenu(props, campusId) : [];
	return (
		<div className="flex flex-col items-center gap-3 bg-dark-green p-4 pt-16">
			<div className="title-h2">
				{props?.first_name || props?.display_name
					? `Hello, ${props.first_name ?? props.display_name}`
					: "Welcome!"}
			</div>
			<div className="flex flex-row flex-wrap justify-center gap-6 text-body-1">
				{accountMenuItems.map((menuItem) => (
					<Link href={menuItem.href} key={menuItem.id}>
						{menuItem.label}
					</Link>
				))}
			</div>
		</div>
	);
};

export default MobileMenuAccountHeader;
